module.exports = __webpack_public_path__ + "img/ditan_xc1.7e5ffc48.jpg";